import $ from 'jquery';
const is_mobile_nav = () => $("#burger-menu").is(':visible');


export {is_mobile_nav};
